<template>
  <div>
    <v-row>
      <v-col class="text-right">
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">Create New Office</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      aria-autocomplete="off"
                      label="Name*"
                      v-model="name"
                      required
                      hint="Make sure it's easy to remember"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      aria-autocomplete="off"
                      label="Location*"
                      v-model="location"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      :items="allOfficeGroups"
                      label="Select Office Group"
                      item-value="id"
                      v-model="group_id"
                    >
                      <template slot="selection" slot-scope="{ item }">
                        <!-- HTML that describe how select should render selected items -->
                        {{ item.name }}
                      </template>
                      <template slot="item" slot-scope="{ item }">
                        <!-- HTML that describe how select should render selected items -->
                        {{ item.name }}
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12" v-if="errorMessage">
                    <h3 class="text-center red--text">{{ errorMessage }}</h3>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close()">Close</v-btn>
              <v-btn color="blue darken-1" text @click="saveOffice" :disabled="disableSave">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <loading-overlay v-if="loading"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Swal from 'sweetalert2';
import LoadingOverlay from "./common/LoadingOverlay.vue";

export default {
  name: "OfficeModal",
  props: {
    dialog: Boolean,
    editedItem: Object,
  },
  components: {
    LoadingOverlay
  },
  data() {
    return {
      disableSave: false,
      loading: false,
      name: "",
      location: "",
      type: "Office",
      status: "Active",
      group_id: null,
      errorMessage: null,
      showSuccess: false,
    };
  },
  methods: {
    ...mapActions(["createOffice", 'updateOffice', 'fetchOfficeGroups']),
    async saveOffice() {
      this.disableSave = true
      this.loading = true
      this.errorMessage = null;
      let body = {
        name: this.name,
        location: this.location,
        type: this.type,
        status: this.status,
        group_id: this.group_id
      };
      let save;
      if(this.editedItem) {
        body = Object.assign(this.editedItem, body);
        save = await this.updateOffice(body);
      } else {
        save = await this.createOffice(body);
      }

      if(save.error) {
        this.disableSave = false
        this.loading = false
        if(save.status == 400) this.errorMessage = save.message;
        else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Internal Server Error',
          })
        }
      } else if(save) {
        this.disableSave = false
        this.loading = false
        this.showSuccess = true;
        this.name = '';
        this.location = '';
        this.errorMessage = null;
        this.$emit('closeDialog', true);
      }
    },
    close() {
      this.errorMessage = null;
      this.location = '';
      this.name = '';
      this.$emit('closeDialog', false);
    },
  },
  computed: mapGetters(["allOffices", 'allOfficeGroups']),
  watch: {
    editedItem: function () {
      if(this.editedItem) {
        this.name = this.editedItem.name;
        this.location = this.editedItem.location;
        this.type = this.editedItem.type;
        this.status = this.editedItem.status;
        this.group_id = this.editedItem.group_id;
      }
    }
  },
  created() {
    this.fetchOfficeGroups({ itemsPerPage: 0 });
  }
};
</script>

<style>
</style>